import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import classes from './LandingMenuItem.css';
import Arrow from '../../../UI/Arrow/Arrow';

const landingMenuItem = props => {
  const { toPage, menuItemTitle, menuItemDesc } = props;
  return (
    <li>
      <Link
        to={toPage}
        style={{ textDecoration: 'none' }}
        className={classes.LandingMenuItem}
      >
        <div className={classes.MenuItemWraaper}>
          <h2>{menuItemTitle}</h2>
          <p> {menuItemDesc} </p>
        </div>
        <Arrow className={classes.MenuItemArrow} direction="next" />
      </Link>
    </li>
  );
};

landingMenuItem.propTypes = {
  toPage: PropTypes.string.isRequired,
  menuItemTitle: PropTypes.string.isRequired,
  menuItemDesc: PropTypes.string.isRequired
};

export default landingMenuItem;
